export const BIZ = {
  name: "Plumberoo",
  legal: "Plumberoo Plumbing & Gas Pty Ltd",
  phone: "0418 355 354",
  tel: "tel:0418355354",
  licence: "PL9967",
  email: "service@myplumberoo.com.au",
  mailto: "mailto:service@myplumberoo.com.au",
  address: "29 Hampden St, South Perth WA 6151",
  addressNote: "Mobile service — we come to you across Perth",
  hours: "Mon–Fri 7:00am – 5:00pm",
  emergency: "After-hours service available",
  googleReviews: "https://www.google.com/search?q=Plumberoo+Plumbing+%26+Gas+reviews",
};

export const NAV = [
  ["services", "Services"],
  ["hot-water", "Hot Water"],
  ["filtration", "Filtration"],
  ["why-us", "Why Us"],
  ["reviews", "Reviews"],
  ["areas", "Areas"],
  ["faq", "FAQ"],
  ["quote", "Contact"],
];

export const FAQS = [
  {
    q: "How long does a hot water system last?",
    a: "Most storage hot water systems last around 8 to 12 years, and continuous flow (instantaneous) gas units often go 15 to 20 years with regular servicing. Signs yours is on the way out include rusty or discoloured water, water pooling around the base, rumbling noises from the tank, and running out of hot water sooner than it used to. If your system is over 10 years old and playing up, it is usually worth having it assessed before it fails completely.",
  },
  {
    q: "What are the signs of a blocked drain?",
    a: "Common warning signs are water draining slowly from sinks, showers or the bath, gurgling sounds from drains or the toilet after flushing, bad smells coming up from the drain, and water backing up or pooling around floor wastes outside. If more than one fixture is affected at once, the blockage is likely in the main sewer line rather than a single pipe, and that is a job for a licensed plumber.",
  },
  {
    q: "What should I do if I smell gas?",
    a: "Treat it as an emergency. Do not use any appliances, light switches, matches or lighters. Open doors and windows, turn off the gas at the meter if it is safe to reach, and move everyone outside. Call your gas distributor's emergency line from outside the property, or 000 if anyone feels unwell or there is immediate danger. Once the area is safe, a licensed gas fitter can locate and repair the leak.",
  },
  {
    q: "Is a burst pipe an emergency?",
    a: "Yes. The first step is to turn off the water at the mains, which is usually at the front of the property near the water meter. Then switch off your hot water system if the leak is on the hot side, and move anything valuable away from the water. Plumberoo offers after-hours service for urgent jobs like burst pipes and major leaks.",
  },
  {
    q: "Do I need a water filtration system in Perth?",
    a: "Perth's scheme water is safe to drink, but many homeowners choose filtration to remove chlorine taste and odour, sediment and scale. A whole-house system treats every tap, shower and appliance, while an under-sink system focuses on drinking water in the kitchen. The right option depends on your household, your plumbing and what you want to remove.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes. Plumberoo Plumbing & Gas Pty Ltd holds WA plumbing licence PL9967, is fully insured and is a Water Corporation Waterwise plumber. All work is carried out by a licensed plumber and gas fitter.",
  },
];

export const SERVICES = [
  "Blocked Drains",
  "Hot Water",
  "Emergency Repair",
  "Gas Fitting",
  "Water Filtration",
  "Renovations & Commercial",
  "Other",
];

export const REVIEW = {
  text: "Sam arrived within the hour, found the burst pipe quickly and had everything repaired and cleaned up. Great communication and top quality work. Highly recommended!",
  author: "Matt",
  location: "Perth",
};

export const SUBURBS = [
  "Perth CBD", "Subiaco", "Fremantle", "Joondalup", "Scarborough", "Cottesloe",
  "Midland", "Rockingham", "Mandurah", "Armadale", "Cannington", "Morley",
  "Wanneroo", "Victoria Park", "Claremont", "Nedlands", "Bayswater", "Belmont",
  "Canning Vale", "Baldivis", "Ellenbrook", "Kalamunda", "Osborne Park", "Stirling",
];

export const MARQUEE = ["Blocked Drains", "Hot Water", "Gas Fitting", "Emergency Repairs", "Water Filtration", "Renovations"];
